<template>
    <div class="patient-details">
        <div class="profile-status">
            <p class="fw-bold" v-if="getBranchName">{{ getBranchName.name }}</p>
            <div class="pic">
                <span
                    v-if="selectedPatientDetails.photoUrl"
                    class="uploaded-pic"
                    ref="userPicElement"
                    :style="{ backgroundImage: `url(${selectedPatientDetails.photoUrl})` }"
                ></span>
                <i v-else class="no-pic fas fa-user"></i>
            </div>
            <p class="fw-bold">
                {{ String(statusEnum.getDescriptionUsingValue(selectedPatientDetails.status)).toLocaleUpperCase() }}
            </p>
        </div>
        <HCPatientMain :selectedPatientDetails="selectedPatientDetails" />
    </div>
</template>

<script lang="ts" src="./HCProfileDetails.ts"></script>
